import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/question.svg'
import _imports_1 from '@/assets/printing-assets/issue-1.svg'
import _imports_2 from '@/assets/printing-assets/issue-2.svg'
import _imports_3 from '@/assets/printing-assets/issue-3.svg'
import _imports_4 from '@/assets/printing-assets/issue-4.svg'


_pushScopeId("data-v-40ad7caf")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "title" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
    /*#__PURE__*/_createElementVNode("span", null, "Which example best matches your alignment issue?")
  ])
], -1)
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { id: "printing-issues" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "issue-number" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "img-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "The artwork is smaller than the labels", -1)
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "issue-number" }, [
  /*#__PURE__*/_createElementVNode("span", null, "2")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "img-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "The artwork is shifted up or down", -1)
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "issue-number" }, [
  /*#__PURE__*/_createElementVNode("span", null, "3")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "img-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 })
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "The artwork is not evenly spaced with the sheet", -1)
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "issue-number" }, [
  /*#__PURE__*/_createElementVNode("span", null, "4")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "img-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_4 })
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "The artwork is shifted left or right", -1)
const _hoisted_19 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "None of these match my problem ›", -1)
const _hoisted_21 = [
  _hoisted_20
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.bounceTransition, "modal-body"])
      }, [
        _createElementVNode("div", {
          class: "close-svg",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _createVNode(_component_CloseSVG, {
            propId: 'print-close',
            fillColor: '#f7f9fc'
          })
        ]),
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "issue",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectIssue(1)))
            }, _hoisted_7),
            _createElementVNode("div", {
              class: "issue",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectIssue(2)))
            }, _hoisted_11),
            _createElementVNode("div", {
              class: "issue",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectIssue(3)))
            }, _hoisted_15),
            _createElementVNode("div", {
              class: "issue",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectIssue(4)))
            }, _hoisted_19)
          ])
        ]),
        _createElementVNode("div", {
          class: "modal-footer",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openContact()))
        }, _hoisted_21)
      ], 2)
    ], 2)
  ]))
}